import { useMediaQuery } from 'react-responsive';

import { Breakpoints } from '@/hooks';

export const useIsSmallerThanTabletSm = () => {
  return useMediaQuery({
    query: `(min-width: 0px) and (max-width: ${Breakpoints.tabletSm}px)`,
  });
};
